export const FILTERS_BUTTON_TEXT = "Filters";
export const STOPS_HEADER_TEXT = "Stops";
export const PRICE_HEADER_TEXT = "Price";
export const AIRLINE_HEADER_TEXT = "Airline";
export const DEPARTURE_HEADER_TEXT = "Departure";
export const ARRIVAL_HEADER_TEXT = "Arrival";
export const AIRPORTS_HEADER_TEXT = "Airports";
export const FLIGHT_NUMBER_HEADER_TEXT = "Flight #";
